/**
 * Cupón que el visitante trae desde /promo (?cupon=CODIGO). Se guarda en localStorage para que
 * sobreviva al alta (email, Google o WhatsApp) y, una vez logueado, App.tsx lo manda a
 * POST /api/checkout/pending-coupon: el backend lo aplica cuando el tenant se suscribe.
 */
const KEY = 'pending_coupon';

const normalize = (code?: string | null) => (code || '').trim().toUpperCase().slice(0, 50);

export const getPendingCoupon = (): string | null => {
  try {
    const v = normalize(localStorage.getItem(KEY));
    return v || null;
  } catch {
    return null;
  }
};

export const setPendingCoupon = (code?: string | null) => {
  const v = normalize(code);
  if (!v) return;
  try {
    localStorage.setItem(KEY, v);
  } catch {
    /* modo privado: no pasa nada, el código viaja igual en la URL */
  }
};

export const clearPendingCoupon = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
};

/** Guarda el ?cupon= de la URL actual, si viene. */
export const capturePendingCouponFromUrl = () => {
  try {
    const code = new URLSearchParams(window.location.search).get('cupon');
    if (code) setPendingCoupon(code);
  } catch {
    /* ignore */
  }
};
